import config from '../../config';
import { getHostedDashboardServiceHost, isDashboardLocalDebugMode, isLocalLikeHost } from '../../utils/environmentMode';

const LOCAL_BROWSER_USERS_HOST = 'http://127.0.0.1:8082';
const PRODUCTION_USERS_HOST = 'https://api-users.gophr.app';

const resolveDispatchUsersHost = () => {
	if (isDashboardLocalDebugMode() && isLocalLikeHost(usersHost)) {
		return LOCAL_BROWSER_USERS_HOST;
	}

	return PRODUCTION_USERS_HOST;
};

export const usersHost = config.config.api_users.admin.usersHost;
export const hasuraHost = config.config.api_users.admin.hasuraHost;
export const hasuraRest = config.config.api_users.admin.hasuraRest;
export const wssHasuraHost = config.config.api_users.admin.wssHasuraHost;
const resolveHostedUsersHost = () => {
	const developmentHost = 'https://dev-api-users.gophr.app';
	const productionHost = 'https://api-users.gophr.app';

	if (isDashboardLocalDebugMode()) {
		return process.env.REACT_APP_LOCAL_DEBUG_HOSTED_STAGE === 'production'
			? productionHost
			: developmentHost;
	}

	return getHostedDashboardServiceHost({
		developmentHost,
		productionHost
	});
};

export const hostedUsersHost = resolveHostedUsersHost();
export const dispatchUsersHost = resolveDispatchUsersHost();
export const dispatchUsersHasuraHost = hasuraHost;
export const dispatchDriversHost = dispatchUsersHost;

const resolveDispatchDriversRequestHost = () => {
	if (isDashboardLocalDebugMode() && isLocalLikeHost(dispatchUsersHost)) {
		return dispatchUsersHost;
	}

	return PRODUCTION_USERS_HOST;
};

export const toHostedUsersUrl = url => {
	if (typeof url !== 'string') {
		return url;
	}

	const localUsersHosts = Array.from(new Set([dispatchUsersHost, usersHost].filter(host => isLocalLikeHost(host))));

	if (localUsersHosts.length === 0) {
		return url;
	}

	const matchingHost = localUsersHosts.find(host => url.startsWith(host));

	return matchingHost ? `${hostedUsersHost}${url.slice(matchingHost.length)}` : url;
};

const browserUsersHost = dispatchUsersHost || usersHost;

//Admin routes
export const createSuperMerchant = browserUsersHost + '/admin/create/super-merchant';
export const createDriver = browserUsersHost + '/admin/create/driver';
export const accountingAccess = browserUsersHost + '/admin/accounting/access';
export const localUsersList = roleFilter => {
	const query = roleFilter !== null && roleFilter !== undefined ? '?role=' + encodeURIComponent(roleFilter) : '';
	return browserUsersHost + '/admin/users' + query;
};
export const driverEndpoint = browserUsersHost + '/admin/driver/';
export const driverCompliance = driverIdentifier => browserUsersHost + '/admin/driver/' + encodeURIComponent(driverIdentifier) + '/compliance';
export const driverComplianceProfile = driverIdentifier => browserUsersHost + '/admin/driver/' + encodeURIComponent(driverIdentifier) + '/compliance-profile';
export const driverOnboarding = driverIdentifier => browserUsersHost + '/admin/driver/' + encodeURIComponent(driverIdentifier) + '/onboarding';
export const driverOnboardingProfile = driverIdentifier => browserUsersHost + '/admin/driver/' + encodeURIComponent(driverIdentifier) + '/onboarding-profile';
export const editUser = browserUsersHost + '/admin/edit/'; // + access token
export const userAuth0Activity = auth0Id => browserUsersHost + '/admin/user/' + encodeURIComponent(auth0Id) + '/auth0-activity';
export const merchantPaymentProfile = auth0Id => browserUsersHost + '/admin/merchant-payment-profile/' + encodeURIComponent(auth0Id);
export const merchantStoreAccess = auth0Id => browserUsersHost + '/admin/internal/merchants/' + encodeURIComponent(auth0Id) + '/store-access';
export const storePaymentProfile = storeId => browserUsersHost + '/admin/store-payment-profile/' + encodeURIComponent(storeId);
export const referralPartnersList = browserUsersHost + '/admin/referral-partners';
export const referralPartner = driverIdentifier => browserUsersHost + '/admin/referral-partners/' + encodeURIComponent(driverIdentifier);
export const referralPartnerBusinesses = driverIdentifier => browserUsersHost + '/admin/referral-partners/' + encodeURIComponent(driverIdentifier) + '/businesses';
export const referralPartnerBusinessCandidates = driverIdentifier => browserUsersHost + '/admin/referral-partners/' + encodeURIComponent(driverIdentifier) + '/business-candidates';
export const referralPartnerBusinessAssignment = (driverIdentifier, merchantReferralId) =>
	browserUsersHost + '/admin/referral-partners/' + encodeURIComponent(driverIdentifier) + '/businesses/' + encodeURIComponent(merchantReferralId);
export const dispatchDriversList = (marketIds, options = {}) => {
	const baseHost = resolveDispatchDriversRequestHost() || dispatchDriversHost;
	if (!baseHost) {
		return null;
	}
	const searchParams = new URLSearchParams();
	if (Array.isArray(marketIds) && marketIds.length > 0) {
		searchParams.set('market_ids', marketIds.join(','));
	}
	if (options && options.visibleBounds) {
		const { minLat, maxLat, minLng, maxLng } = options.visibleBounds;
		if (Number.isFinite(minLat) && Number.isFinite(maxLat) && Number.isFinite(minLng) && Number.isFinite(maxLng)) {
			searchParams.set('min_lat', String(minLat));
			searchParams.set('max_lat', String(maxLat));
			searchParams.set('min_lng', String(minLng));
			searchParams.set('max_lng', String(maxLng));
		}
	}
	if (options && options.includeOffline === false) {
		searchParams.set('include_offline', 'false');
	}
	if (options && typeof options.driverStatus === 'string' && options.driverStatus.trim()) {
		searchParams.set('driver_status', options.driverStatus.trim());
	}
	const query = searchParams.toString();
	return baseHost + '/admin/dispatch/drivers' + (query ? `?${query}` : '');
};
